import * as msg from '@/utils/mensagens'
import MensagensHelper, { MSG_ERRO, MSG_ALERTA } from '@/utils/mensagens.helper'
import store from '@/store/index'

export default {
  _possuiErroAutenticacao(erro) {
    return (erro.response && erro.response.status === 401)
  },
  _redirecionarLogin() {
    if (store.getters['autenticacao/userObj'].usuario) {
      store.dispatch('autenticacao/sairDoSistemaStore')
      // eslint-disable-next-line
      location.reload()
    }
  },
  _gerarMensagem(erro) {
    if (!erro.response) {
      return MensagensHelper.gerar(MSG_ERRO, msg.FALHA_CONECTAR_AO_SERVIDOR)
    }

    if (erro.response.data) {
      const mensagemRetorno = MensagensHelper.retornaSomenteMensagens(erro.response.data)
      return MensagensHelper.gerar(MSG_ALERTA, mensagemRetorno)
    }

    return MensagensHelper.gerar(MSG_ERRO, msg.ERRO_INTERNO)
  },
  validar(erro) {
    if (erro.tipo) {
      return erro
    }

    if (this._possuiErroAutenticacao(erro)) {
      this._redirecionarLogin()
      return MensagensHelper.gerar(MSG_ALERTA, msg.ACESSO_NAO_AUTORIZADO)
    }

    return this._gerarMensagem(erro)
  },
}
